// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IOVF', 'IOVF Fallback'"},"className":"__className_95eb54","variable":"__variable_95eb54"};